import React from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '190px',
  },
  socialMediaInteractionsRoot: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const TabPanel = ({ children, value, index }) => {
  const classes = useStyles()
  return (
    <>
      {value === index && (
        <Box
          p={5}
          className={clsx(
            classes.root,
            value === 5 ? classes.socialMediaInteractionsRoot : '',
          )}
        >
          {children}
        </Box>
      )}
    </>
  )
}

export default TabPanel
